var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vagaro-button"},on:{"click":function($event){return _vm.redirectToVagaro()}}},[_vm._v(" Book on Vagaro ")])}
var staticRenderFns = []

export { render, staticRenderFns }